import { mapActions, mapGetters } from 'vuex';
import Helpers from '../helpers';
import { DataTracking } from '../services';
import { APP_DEBUG } from '../environment';

export const activityManagerMixin = {
  computed: {
    ...mapGetters({
      images: 'ActivityManagerModule/getImages',
      data: 'ActivityManagerModule/getData',
      resourceData: 'ActivityManagerModule/getData',
      videos: 'ActivityManagerModule/getVideos',
      audios: 'ActivityManagerModule/getAudios',
      percentLoaded: 'ActivityManagerModule/getPercentage',
      loading: 'ActivityManagerModule/getLoading',
      isActivityLoadingCompleted:
        'ActivityManagerModule/isActivityLoadingCompleted',
      liveMessage: 'ActivityManagerModule/getLiveMessage',
      getImageById: 'ActivityManagerModule/getImageById',
      hasAudioById: 'ActivityManagerModule/hasAudioById',
      getAudioById: 'ActivityManagerModule/getAudioById',
      getVideoById: 'ActivityManagerModule/getVideoById',
      getScale: 'ZoomModule/getScale',
      getZoom: 'ZoomModule/getZoomValue',
      isPreloadCompleted: 'ActivityManagerModule/isPreloadCompleted',
    }),
    helpers: () => Helpers,
  },
  methods: {
    ...mapActions({
      setVideos: 'ActivityManagerModule/setVideos',
      setActivityResources: 'ActivityManagerModule/setActivityResources',
      removeActivityResources: 'ActivityManagerModule/removeActivityResources',
      setLiveMessage: 'ActivityManagerModule/setLiveMessage',
      onSwapComponent: 'ActivityManagerModule/onSwapComponent',
      refreshScale: 'ZoomModule/loadZoom',
      setZoom: 'ZoomModule/setZoom',
      resetZoom: 'ZoomModule/resetZoom',
    }),
    enteredInteractive: function () {
      DataTracking.enteredInteractive();
    },
    correctAnswersInputFirstTry: (drops) => {
      DataTracking.correctAnswersInputFirstTry(drops);
    },
    stopTracking: () => {
      DataTracking.stop();
    },
    focusFirstFocusableElement() {
      const ActivityComp = this.$children.filter(
        (children) => children.$options.name === 'Activity',
      );
      if (ActivityComp.length > 0) {
        const FocusLoopComp = ActivityComp[0].$children.filter(
          (children) => children.$options.name === 'FocusLoop',
        );
        if (FocusLoopComp.length > 0) {
          const CurrentComp = FocusLoopComp[0].$children.filter(
            (children) => children.$options.name === this.currentComponent,
          );
          if (CurrentComp.length > 0) {
            const focusable = CurrentComp[0].$el.querySelectorAll(
              '[tabindex]:not([tabindex="-1"])',
            );
            if (focusable.length > 0) {
              focusable[0].focus();
            }
          }
        }
      }
    },
    log() {
      if (APP_DEBUG) {
        console.log(...arguments);
      }
    },
  },
};
